import { render, staticRenderFns } from "./OrderProduct.vue?vue&type=template&id=13c7fd14&scoped=true"
import script from "./OrderProduct.vue?vue&type=script&lang=js"
export * from "./OrderProduct.vue?vue&type=script&lang=js"
import style0 from "./OrderProduct.vue?vue&type=style&index=0&id=13c7fd14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c7fd14",
  null
  
)

export default component.exports